import "./src/styles/owl.carousel.css"
import "./src/styles/owl.theme.default.min.css"
import "./src/styles/global.css"

export const onClientEntry = () => {
  const loadScript = (src: string) => {
    return new Promise<void>((resolve, reject) => {
      if (document.querySelector(`script[src="${src}"]`)) {
        resolve();
        return;
      }

      const script = document.createElement("script");
      script.src = src;
      script.type = "text/javascript";
      script.async = true;
      script.onload = () => resolve();
      script.onerror = () => reject(new Error(`Failed to load script: ${src}`));
      document.body.appendChild(script);
    });
  };

  const loadCarouselDependencies = async () => {
    try {
      await loadScript("/js/jquery.min.js");
      await loadScript("/js/owl.carousel.js");
    } catch (error) {
      console.error(error);
    }
  };

  loadCarouselDependencies();
}
